import {
  api_create_team_path,
  api_refresh_team_guid_path,
  api_team_path,
  api_update_team_path,
} from '@routes';

import request from './request';

export const TEAM_KEY = 'TEAM_KEY';

export type Team = {
  id?: number;
  name: string;
  email_domain: string;
  guid: string;
  identity_id?: number;
};

export type TeamSetting = {
  team: Team;
  currentOffer: TeamCurrentOffer;
};

export type TeamCurrentOffer = {
  initialPrice: number;
};

export type TeamResponse = {
  team: Team;
  currentOffer: TeamCurrentOffer;
  errors?: string[];
  success: boolean;
};

export type TeamUpdate = {
  name?: string;
  email_domain?: string;
  guid?: string;
};

export async function getTeam(): Promise<TeamResponse> {
  const resp = await request('get', api_team_path());
  return resp;
}

export async function createTeam(values: Pick<Team, 'name'>): Promise<TeamResponse> {
  const resp = await request('post', api_create_team_path(), { team: values });
  return resp;
}

export async function updateTeam(values: TeamUpdate): Promise<TeamResponse> {
  const resp = await request('put', api_update_team_path(), {
    team: values,
  });
  return resp;
}

export async function refreshTeamGuid(): Promise<TeamResponse> {
  const resp = await request('put', api_refresh_team_guid_path());
  return resp;
}
